import {UserDataActions} from '../Redcuers/UserDataSlice';
import {LanguageActions} from '../Redcuers/LanguageSlice';

const Actions = {
  ...UserDataActions,
  ...LanguageActions,
};

export default Actions;
